import 'tippy.js/dist/tippy.css';
import { ApolloProvider } from '@apollo/react-hooks';
import CssBaseline from '@material-ui/core/CssBaseline';
import React, { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import Loading from '~components/loading';
import Router from '~containers/router';
import { SuiteProvider } from '~containers/suite-config/suite-context';
import { ToastProvider } from '~containers/toast/toast-context';
import store from '~store';
import { useInitialApolloClient } from './apollo';
import i18next from './i18next';
import { MuiProviders } from './mui/mui-providers';
import useYupConfig from './yup-config';

function App() {
  useYupConfig();
  const apolloClient = useInitialApolloClient();

  return (
    <ToastProvider>
      <SuiteProvider>
        <ApolloProvider client={apolloClient}>
          <Router />
        </ApolloProvider>
      </SuiteProvider>
    </ToastProvider>
  );
}

function AppWithProviders() {
  return (
    <MuiProviders>
      <CssBaseline />
      <Provider store={store}>
        <I18nextProvider i18n={i18next}>
          <BrowserRouter>
            <Suspense fallback={<Loading />}>
              <App />
            </Suspense>
          </BrowserRouter>
        </I18nextProvider>
      </Provider>
    </MuiProviders>
  );
}

export default AppWithProviders;
